export default __webpack_public_path__ + "static/media/logo.c86bbf02.png";